// // import React from 'react'


// // const login = "/img/login.webp"
// // export default function LoginUtah(prop) {
// //   return (
// //     <div>
      
// //     </div>
// //   )
// // }








// import React from 'react';

// const login = "/img/login.webp";

// export default function LoginUtah(props) {
//   const { name } = props; // Destructure the name from props

//   return (
//     <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-center p-4">
//       <img src={login} alt="Login Illustration" className="w-64 h-auto mb-6" />
//       <h1 className="text-2xl font-bold text-gray-800">
//         Welcome <span className="text-blue-600">{name}</span> to <strong>UtahData.org</strong>
//       </h1>
//     </div>
//   );
// }




import React,{useEffect,useState} from 'react';
import { Link, useLocation,useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ArrowUpRight } from 'lucide-react';
import ScrambleText from '../utils/ScrambleText';
import "../styles/UtahAtAGlance.css"
import axios from 'axios';

const login = "/img/login.webp";

export default function LoginUtah() {
     const location = useLocation();
     const navigate = useNavigate();
     const [user, setUser] = useState(null);
  // const name = location.state?.name || "user"; // fallback if no name
    useEffect(() => {
    axios
      .get("https://utsb.utahdata.org/bdxbackend/auth/me", { withCredentials: true })
      .then(({ data }) => {
        if (data.authenticated) {
          setUser(data.user);
          localStorage.setItem("user",data.user.name); 
        } else {
          setUser(null);
          navigate("/login", { replace: true }); // 🔑 redirect to /login
        }
      })
      .catch(() => {
        setUser(null);
        navigate("/login", { replace: true });   // 🔑 redirect if request fails
      });
  }, [navigate]);
  return (
    <div>
    <Header/>
    <div
      className="min-h-screen bg-cover bg-center flex flex-col items-center justify-center"
      style={{ backgroundImage: `url(${login})` }}
    >
  {user ? (
  <div className="bg-[rgba(255,255,255,0.4)] p-10 pt-[4rem] rounded-lg text-center text-white">
  <h1
    className="text-3xl font-bold mb-2 text-black"
  
  >
    Welcome{" "}
    <span
      className="text-blue-900"
     
    >
      {user?.name}!
    </span>
  </h1>
  <span
    className="text-3xl font-bold text-black"
    
  >
    Thank you for Logging in
  </span>
  <div className="mt-4">
    <h1
      className="text-3xl font-bold text-black"
     
    >
      Start exploring <span className='text-red-700'>UTah</span><span className='text-red-700'>Data.org</span> with{" "}
      <span>
        <Link
          to={"/search"}
          className="no-underline text-blue-900"
         
        >
          {" "}
          BETSY{" "}
          <img src='/img/Betsy.png' className='h-14 w-auto' alt="Betsy" />
        </Link>
      </span>
    </h1>
  </div>
</div>
) : (
        <p>Checking authentication...</p>
      )}

                </div>
    <Footer/>
    </div>
  );
}
